// extracted by mini-css-extract-plugin
module.exports = {"result-stats":"result-stats__I0p_O","result-stats-desktop":"result-stats-desktop__KrcXp","result-stats-mobile":"result-stats-mobile__vBmwS"};